import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Lightbulb } from "lucide-react";

// Empty-state teaching slot: plays James's short vertical video once the file
// ships (listed in /help-videos/empty/manifest.json); until then the text tip.
// Video: MP4, captioned, playsInline, poster image, in-app (never YouTube).
let manifestCache = null;

export default function EmptyTip({ slot }) {
  const { t, i18n } = useTranslation();
  const [hasVideo, setHasVideo] = useState(false);
  useEffect(() => {
    let live = true;
    (manifestCache
      ? Promise.resolve(manifestCache)
      : fetch("/help-videos/empty/manifest.json")
          .then((r) => (r.ok ? r.json() : {}))
          .then((m) => (manifestCache = m || {}))
    ).then((m) => { if (live) setHasVideo(!!m?.[slot]); }).catch(() => {});
    return () => { live = false; };
  }, [slot]);

  if (hasVideo) {
    const es = i18n.language?.startsWith("es");
    return (
      <video controls preload="none" playsInline
        poster={`/help-videos/empty/${slot}.jpg`}
        className="mx-auto mt-4 aspect-[9/16] w-44 rounded-xl bg-slate-900"
        data-testid={`empty-video-${slot}`}>
        <source src={`/help-videos/empty/${slot}${es ? "_es" : ""}.mp4`} type="video/mp4" />
        <track kind="captions" src={`/help-videos/empty/${slot}${es ? "_es" : ""}.srt`}
          srcLang={es ? "es" : "en"} label={es ? "Español" : "English"} default />
      </video>
    );
  }
  return (
    <p className="mx-auto mt-3 flex max-w-md items-center justify-center gap-1.5 text-xs text-slate-400"
      data-testid={`empty-tip-${slot}`}>
      <Lightbulb className="h-3.5 w-3.5 shrink-0 text-brand" /> {t(`empty_tip_${slot}`)}
    </p>
  );
}
